import React, { useEffect, useState } from 'react'
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage'
import useCorsiUtenti from '../../hooks/useCorsiUtenti';
import useUtenti from '../../hooks/useUtenti';
import useCorsi from '../../hooks/useCorsi';
import CustomModal from '../../components/CustomModal/CustomModal';
import SearchCorso from '../../components/SearchCorso/SearchCorso';
import HorizontalCourseCard from '../../components/HorizontalCourseCard/HorizontalCourseCard';
import { Dropdown, OverlayTrigger, Spinner, Table, Tooltip } from 'react-bootstrap';
import UtilityService from '../../services/UtillityServices/UtilityService';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import useMediaQuery from '../../hooks/useMediaQuery';
import { alertService } from '../../services/AlertService';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import useAuth from '../../hooks/useAuth';
import CustomSearch from '../../components/CustomSearch/CustomSearch';
import useClassiUtenti from '../../hooks/useClassiUtenti';

const AssegnaCorsiPage = () => {
  const {
    assignCourseToUser,
    modalStateCorsiUtenti,
    loadingStateCorsiUtenti,
    setModalStateCorsiUtenti,
    deleteCorsiUtenti
  } = useCorsiUtenti();

  const {
    getAllUtenti,
    findUsersByRole,
    loadingStateUtenti,
    getUtenteByParams
  } = useUtenti();

  const { getClassiByParamsNoAuth } = useClassiUtenti();

  const {
    findCorsiByIdUtente,
    loadingStateCorsi,
    getCorsiByParams
  } = useCorsi();

  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [utenti, setUtenti] = useState([]);
  const [corsi, setCorsi] = useState([]);
  const [corsiUtentiAssignedPerUser, setCorsiUtentiAssignedPerUser] = useState([]);
  const [corsiUtentiAlreadyAssignedPerUser, setCorsiUtentiAlreadyAssignedPerUser] = useState([]);
  const [newCorsiUtentiAssignedPerUser, setNewCorsiUtentiAssignedPerUser] = useState([]);
  const [deleteCorsiUtentiAssignedPerUser, setDeleteCorsiUtentiAssignedPerUser] = useState([]);
  const userLoggedIn = useSelector(state => state.user.userData);
  const [formAssegnaCorso, setFormAssegnaCorso] = useState({});
  const [paymentOption, setPaymentOption] = useState('self');
  const [voucherOption, setVoucherOption] = useState("1");

  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1);
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingUtenti, setIsLoadingUtenti] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);

  const handleRowClick = (id) => {
    setSelectedRow(prevSelectedRow => prevSelectedRow === id ? null : id);
  };

  useEffect(() => {
    if (!isLoadingUtenti) {
      printAllUtenti();
    }
  }, [orderBy, orderType, selectedPage])

  const fetchUtenti = async (obj) => {
    setIsLoadingUtenti(true);
    let utentiList;
    obj = {
      ...obj,
      filtri: {
        ...obj.filtri,
        attivo: 1,
      }
    };

    if(!obj?.filtri?.tipo_utente) {
      if(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.DEVELOPER){
        obj = {
          ...obj,
          filtri: {
            ...obj.filtri,
            tipo_utente: ["course_designer", "docente", "tutor", "corsista"]
          }
       }
      }
      if(userLoggedIn.role === ROLES.COURSE_DESIGNER){
        obj = {
          ...obj,
          filtri: {
            ...obj.filtri,
            tipo_utente: ["docente", "tutor", "corsista"]
          }
       }
      }
    }

    if (userLoggedIn?.role === ROLES.PARTNER) {
      obj = {
        ...obj,
        filtri: {
          ...obj.filtri,
          id_agenzia: userLoggedIn?.id_agenzia,
        }
      };
    }
  
    const fetchUtentiList = await getUtenteByParams(obj);
    const countPagination = Math.ceil(fetchUtentiList?.count / obj.limite);
    setTotalPages(countPagination);
    utentiList = fetchUtentiList?.data ?? [];
    setUtenti(utentiList);
    setIsLoadingUtenti(false);
    if(utentiList?.length === 0){
      setSelectedPage(1)
    }
  };
  
  const printAllUtenti = async () => {
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: `${orderBy ?? "nome"} ${orderType ?? "asc"}`
    };
  
    await fetchUtenti(obj);
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "nome"} ${orderType ?? "asc"}`
    };
    await fetchUtenti(obj);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const printAllCorsi = async (user) => {
    let fetchCorsiList;
    const res = await getCorsiByParams({});
    fetchCorsiList = res?.data;
    setCorsi(fetchCorsiList);
    const userId = {id_utente: user?.id_utente}
    printCorsiUtenteByUserId(userId)
  }

  const printCorsiUtenteByUserId = async (id) => {
    const CorsiUtentiByUserId = await findCorsiByIdUtente(id);
    setCorsiUtentiAlreadyAssignedPerUser(CorsiUtentiByUserId);
    setCorsiUtentiAssignedPerUser(CorsiUtentiByUserId);
 }

  const handleStatoPagamentoChange = (event) => {
    const selectedOption = event.target.value;
    setFormAssegnaCorso((prevState) => ({ ...prevState, stato_pagamento: selectedOption }));
  }

  const handlePercScontoChange = (event) => {
    const selectedOption = event.target.value;
    setFormAssegnaCorso((prevState) => ({ ...prevState, sconto: selectedOption }));
  }
  
  const handleCloseModal = () => {
    setModalStateCorsiUtenti(state => ({ 
      ...state,
      assignCourseToUser: false
    }));
    setSelectedCourse(null);
    setNewCorsiUtentiAssignedPerUser([]);
    setDeleteCorsiUtentiAssignedPerUser([]);
    setCorsiUtentiAssignedPerUser([]);
  }

  const openAssegnCourseModal = (user) => {
    setSelectedUser(user)
    printAllCorsi(user);
    setModalStateCorsiUtenti(state => ({...state, assignCourseToUser: true}))
  }

  const onAssignCourse = () => {
    if (!corsiUtentiAssignedPerUser.some(corso => corso.id_corso == selectedCourse.id_corso)) {
      if(userLoggedIn?.role === ROLES.ADMIN  || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER){
        selectedCourse.stato_pagamento = formAssegnaCorso.stato_pagamento;
        if(selectedUser.tipo_utente === "corsista"){
          if(selectedCourse.stato_pagamento !== "Non_pagato" && selectedCourse.stato_pagamento !== "Pagato" && selectedCourse.stato_pagamento !== "Parzialmente_pagato"){
            alertService.warn("Seleziona uno stato di pagamento del corso", {autoClose: true});
            return;
          }
        }
      }

      if(userLoggedIn?.role === ROLES.PARTNER){
        selectedCourse.pagamento_partner = paymentOption == "corsista" ? "0" : "1";
        selectedCourse.sconto_corsista = (voucherOption == "1" && selectedCourse.pagamento_partner == "1") ? "0" : voucherOption;
        if(paymentOption == "corsista" && voucherOption == "1") {
          selectedCourse.sconto = formAssegnaCorso?.sconto;
        } else {
          delete formAssegnaCorso?.sconto;
          delete selectedCourse?.sconto;
        }
      }
      setNewCorsiUtentiAssignedPerUser(prev => [...prev, selectedCourse])
      setCorsiUtentiAssignedPerUser(prev => [...prev, selectedCourse]);
      setSelectedCourse(null)
    } else {
      alertService.warn("Il corso è già stato assegnato all'utente", {autoClose: true});
    }
  }
  

  const onUpdateCorsiUtenti = async () => {
    if(deleteCorsiUtentiAssignedPerUser?.length > 0) {
      for (const corso of deleteCorsiUtentiAssignedPerUser) {
            const obj = {id_corso_utente: corso?.id_corso_utente, denominazione: corso?.denominazione}
            await deleteCorsiUtenti(obj);
       }
    }
    if(newCorsiUtentiAssignedPerUser?.length > 0) {
      for (const corso of newCorsiUtentiAssignedPerUser) {
            const obj = {
              denominazione: corso.denominazione,
              tipo_pagamento: "Paypal_o_Carta_di_Credito",
              stato_pagamento: corso?.stato_pagamento ?? "Non_pagato",
              modalita_fatturazione: "A",
              tipo_titolo_rilasciato: "Attestato_di_qualifica",
              stato_pagamento_attestato: "Non_pagato",
              richiesta_esame_da_approvare: "1",
              bypass: "0",
              contratto_accettato: "1",
              eliminato: "0",
              pagamento_partner: corso?.pagamento_partner ?? "0",
              sconto_corsista: corso?.sconto_corsista ?? "0",
              sconto: corso?.sconto,
              id_corso: corso?.id_corso,
              id_utente: selectedUser?.id_utente
            }
            await assignCourseToUser(obj, true);
       }
    }
    handleCloseModal();
  }

  const onRemoveCourse = (id) => {
    setCorsiUtentiAssignedPerUser(prevCourses => prevCourses.filter(course => course.id_corso != id));
    setNewCorsiUtentiAssignedPerUser(prevCourses => prevCourses.filter(course => course.id_corso != id));

    corsiUtentiAlreadyAssignedPerUser.some(corso => {
    if(corso.id_corso == id) {
      setDeleteCorsiUtentiAssignedPerUser([...deleteCorsiUtentiAssignedPerUser, corso]);
    } 
   }) 
  }

    const handlePaymentOptionChange = (e) => {
    setPaymentOption(e.target.value);
  };

  const handleVoucherOptionChange = (e) => {
    setVoucherOption(e.target.value);
  };


  const renderBodyModal = () => {
    return !loadingStateCorsi.isLoadingCorsiByParams && !loadingStateCorsi.isLoadingCorsiByIdUtente ? (
      <div className='row'>
      <div className='col-sm-12 col-xl-6'>
      <CustomSearch
            field={"denominazione_corso"}
            label={"Cerca corso"}
            searchApi={getClassiByParamsNoAuth}
            placeholder={"Nome del corso"}
            selectedItem={selectedCourse}
            setSelectedItem={setSelectedCourse}
            showDate={true}
              />
   {/*    <SearchCorso courses={corsi} setSelectedCourse={setSelectedCourse} selectedCourse={selectedCourse}/> */}
      {selectedCourse && (
            <>
            <span className='small text-muted d-block mb-1'><b>Corso selezionato</b></span>
            <span>{selectedCourse?.denominazione} ({selectedCourse?.codice})</span>
            </>  
       ) }
      {selectedCourse?.denominazione &&
      <>
      { selectedUser.tipo_utente === "corsista" && (
        renderStatoPagamento()
       )}
       {
        selectedUser.tipo_utente === "corsista" && (
          (userLoggedIn?.role === ROLES.PARTNER) && (
            <>
            {renderPartnerPaymentOptions()}
            {
              paymentOption === "corsista" && (
                renderPartnerVoucherOptions()
              )
            }
            {
              paymentOption === "corsista" && voucherOption === "1" && (
                <>
                 <span className='d-block text-muted'><b>Inserisci sconto</b></span>
                <input name="sconto" value={formAssegnaCorso.sconto || ''} onChange={handlePercScontoChange} className="form-control" type="number" placeholder="Inserisci sconto" aria-label="Sconto"/>
                </>
              )
            }
            </>
            )
        )
      }
      <div className='my-3'>
       <button className='btn btn-primary my-3 w-100' onClick={onAssignCourse}>Assegna corso</button>
     </div>
      </>
      }
      </div>
      <div className='col-sm-12 col-xl-6' style={{borderLeft: `${isWideScreen ? "1px solid #d8d8d8" : ""}`}}>
      {(corsiUtentiAssignedPerUser?.length > 0) ? (
        <>
          <span className='d-block text-muted'><b>Lista corsi di {selectedUser?.nome} {selectedUser?.cognome}</b> ({selectedUser?.tipo_utente === "course_designer" ? "course designer" : selectedUser?.tipo_utente})</span>
          {corsiUtentiAssignedPerUser?.map(corso => (
            <div key={corso.id_corso}>
              <HorizontalCourseCard
                userLoggedIn={userLoggedIn}
                selectedRole={selectedUser?.tipo_utente} 
                course={corso}
                cardStyle={"shadow"} 
                onRemoveCourse={onRemoveCourse}
                courseDesignerCorsi={corsi}
                partnerNewCorsi={newCorsiUtentiAssignedPerUser}
                />
            </div>
          ))}
        </>
      ) : (
        <div className='mt-5 text-center'>
      <p className='text-muted'>Nessun corso assegnato all'utente.</p>
      <i className="bi bi-mortarboard fs-1 text-secondary"></i>
        </div>
      )}
    </div>
      </div>
    ) : (
      <div className='text-center'>
        <Spinner as="span" animation="border" size="xl" role="status" className="my-5"/>
      </div>
    )
  }

  const renderPartnerPaymentOptions = () => (
    <div className="col-12 my-3">
         <span className='small text-muted d-block mb-1'><b>Pagamento</b></span>
        <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
          <input
            type="radio"
            className="btn-check"
            name="paymentOption"
            id="selfPayment"
            value="self"
            autoComplete="off"
            checked={paymentOption === 'self'}
            onChange={handlePaymentOptionChange}
          />
          <label className="btn btn-outline-primary" htmlFor="selfPayment">
            Pagamento a proprio carico
          </label>

          <input
            type="radio"
            className="btn-check"
            name="paymentOption"
            id="corsistaPayment"
            value="corsista"
            autoComplete="off"
            checked={paymentOption === 'corsista'}
            onChange={handlePaymentOptionChange}
          />
          <label className="btn btn-outline-primary" htmlFor="corsistaPayment">
            Pagamento a carico del corsista
          </label>
        </div>
    </div>
    )
  
    const renderPartnerVoucherOptions = () => (
    <div className="col-12 my-3">
         <span className='small text-muted d-block mb-1'><b>Applica sconto</b></span>
        <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
          <input
            type="radio"
            className="btn-check"
            name="voucherOption"
            id="yes-voucher"
            value="1"
            autoComplete="off"
            checked={voucherOption === "1"}
            onChange={handleVoucherOptionChange}
          />
          <label className="btn btn-outline-primary" htmlFor="yes-voucher">
            Applica
          </label>

          <input
            type="radio"
            className="btn-check"
            name="voucherOption"
            id="no-voucher"
            value="0"
            autoComplete="off"
            checked={voucherOption === "0"}
            onChange={handleVoucherOptionChange}
          />
          <label className="btn btn-outline-primary" htmlFor="no-voucher">
            Non applicare
          </label>
        </div>
    </div>
    )

  const renderStatoPagamento = () => {
    if(userLoggedIn?.role === ROLES.ADMIN  || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER) {
      return (
      <div className='col-12 my-3'>
        <span className='small text-muted d-block mb-1'><b>Stato pagamento</b></span>
        <select name="stato_pagamento" className="form-control" value={formAssegnaCorso.stato_pagamento || ''} onChange={handleStatoPagamentoChange}>
        <option value="">Seleziona uno stato di pagamento</option>
          <option value="Pagato">Pagato</option>
          <option value="Non_pagato">Non pagato</option>
          <option value="Parzialmente_pagato">Parzialmente pagato</option>
        </select>
      </div>
      )
    }
    return null;
  }

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };
  

  return (
    <>
        <div
          className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}
          style={{ minHeight: "700px" }}>
            <div className="container">
              <div className="d-flex justify-content-between custom-card-header">
                <div className="d-flex gap-3 custom-card-title">
                  <div className={`custom-icon-container`}>
                    <i className={`bi custom-icon bi-mortarboard fs-2`}></i>
                  </div>
                  <div className="align-self-center">
                    <span className="fs-4 d-block">
                      <i>
                        <b>Assegna corsi</b>
                      </i>
                    </span>
                  </div>
                </div>
              </div>
              <div className='mt-5'>
                <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isAssegnaCorso={true}
                  isLoadingData={loadingStateUtenti.isLoadingUtenteByParams}
                  searchNodeType={
                   userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER ?
                    ([
                    {nodeType: "input", name: "nome"},
                    {nodeType: "input", name: "cognome"},
                    {nodeType: "input", name: "username", placeholder: "email"},
                    {nodeType: "select", name: "tipo_utente"},
                  ]) : (
                  [ {nodeType: "input", name: "nome"},
                    {nodeType: "input", name: "cognome"},
                    {nodeType: "input", name: "username", placeholder: "email"},
                  ]
                  )
                }
                />
              </div>
              <>
           {  !loadingStateUtenti.isLoadingUtenteByParams ? (
            <>
                 {(!utenti || utenti?.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono utenti da mostrare.</p>
                    </div>) : (
                    <>
              <Table responsive striped className='mt-4' bordered hover>
              <thead className='bg-dark text-light'>
                  <tr>
                    <th scope="col">
                    <div className='d-flex justify-content-between'>
                      <span className='align-self-center'>Nome
                      {orderBy === "nome" && orderType === "asc" && (<i className="bi bi-arrow-up ms-1"></i>)}
                      {orderBy === "nome" && orderType === "desc" && (<i className="bi bi-arrow-down ms-1"></i>)}
                      </span>
                      <Dropdown>
                    <Dropdown.Toggle size="sm" variant='secondary'>
                    <i className="bi bi-list"></i>
                    </Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleOrder("nome", "asc")}><i className="bi bi-arrow-up me-1"></i> Ascendente</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleOrder("nome", "desc")}><i className="bi bi-arrow-down me-1"></i> Discendente</Dropdown.Item>
                  </Dropdown.Menu>
                   </Dropdown>
                    </div>
                    </th>
                    <th scope="col">
                    <div className='d-flex justify-content-between'>
                      <span className='align-self-center'>Cognome
                      {orderBy === "cognome" && orderType === "asc" && (<i className="bi bi-arrow-up ms-1"></i>)}
                      {orderBy === "cognome" && orderType === "desc" && (<i className="bi bi-arrow-down ms-1"></i>)}
                      </span>
                      <Dropdown>
                    <Dropdown.Toggle size="sm" variant='secondary'>
                    <i className="bi bi-list"></i>
                    </Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleOrder("cognome", "asc")}><i className="bi bi-arrow-up me-1"></i> Ascendente</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleOrder("cognome", "desc")}><i className="bi bi-arrow-down me-1"></i> Discendente</Dropdown.Item>
                  </Dropdown.Menu>
                   </Dropdown>
                    </div>
                    </th>
                    <th scope="col">
                    <div className='d-flex justify-content-between'>
                      <span className='align-self-center'>Ruolo
                      {orderBy === "tipo_utente" && orderType === "asc" && (<i className="bi bi-arrow-up ms-1"></i>)}
                      {orderBy === "tipo_utente" && orderType === "desc" && (<i className="bi bi-arrow-down ms-1"></i>)}
                      </span>
                      <Dropdown>
                      <Dropdown.Toggle size="sm" variant='secondary'>
                      <i className="bi bi-list"></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleOrder("tipo_utente", "asc")}><i className="bi bi-arrow-up me-1"></i> Ascendente</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleOrder("tipo_utente", "desc")}><i className="bi bi-arrow-down me-1"></i> Discendente</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    </div>
                    </th>
                    <th scope="col">
                    <div className='d-flex justify-content-between'>
                      <span className='align-self-center'>Email
                      {orderBy === "username" && orderType === "asc" && (<i className="bi bi-arrow-up ms-1"></i>)}
                      {orderBy === "username" && orderType === "desc" && (<i className="bi bi-arrow-down ms-1"></i>)}
                      </span>
                        <Dropdown>
                      <Dropdown.Toggle size="sm" variant='secondary'>
                      <i className="bi bi-list"></i>
                      </Dropdown.Toggle>
                    <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleOrder("username", "asc")}><i className="bi bi-arrow-up me-1"></i> Ascendente</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleOrder("username", "desc")}><i className="bi bi-arrow-down me-1"></i> Discendente</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                    </div>
                    </th>
                    <th scope="col" style={{alignContent: "center"}}>
                      <div className="text-end">
                       Azioni
                      </div>
                     </th>
                  </tr>
                </thead>
                <tbody>
                  {utenti?.map((utente) =>
                      <tr key={utente.id_utente} className={selectedRow === utente.id_utente ? 'selected-row' : ''} onClick={() => handleRowClick(utente.id_utente)}>
                        <td>{utente?.nome}</td>
                        <td>{utente?.cognome}</td>
                        <td>{(utente?.tipo_utente === "course_designer") ? "course designer" : utente.tipo_utente}</td>
                        <td>{utente?.username}</td>
                        <td className="text-end">
                          <>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-info">Assegna corsi</Tooltip>}
                          >
                        <i role='button' onClick={() => openAssegnCourseModal(utente)} className="bi bi-gear-fill fs-5 mx-1 text-primary"></i> 
                          </OverlayTrigger>
                        </>
                        </td>
                      </tr>
                  )}
                </tbody>
           </Table>
             <div className="d-flex justify-content-end mt-1">
               <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                  />
             </div>
              </>
             )}
            </>
           ) : (
            <LoadingTable loadingCol={5}/>
           )}
             </>
            </div>
        </div>
         <CustomModal
          show={modalStateCorsiUtenti.assignCourseToUser}
          onHide={handleCloseModal}
          headerText="Assegna corso"
          size={"xl"}
          btnText={"Salva"}
          body={renderBodyModal()} 
          closeButton={true}
          isLoading={loadingStateCorsiUtenti.isLoadingCorsiUtentiCreating || loadingStateCorsiUtenti.isLoadingCorsiUtenteDeleting}
          onUndoChanges={handleCloseModal} 
          onSave={onUpdateCorsiUtenti}
        />
      </>
  )
}

export default AssegnaCorsiPage